import React, { FunctionComponent, useLayoutEffect, useRef } from 'react';
import { Presentation } from './presentation';
import type { ProfilesStepBarPrpps as Props } from './types';
import { smoothScrollX } from '../../../libs/scrollUtils';

export const Component: FunctionComponent<Props> = (props) => {
  const containerRef = useRef<HTMLUListElement>(null);
  const itemRefs = useRef<(HTMLLIElement | null)[]>([]);
  const cancelRef = useRef<(() => void) | null>(null);

  useLayoutEffect(() => {
    const container = containerRef.current;
    const currentItem = itemRefs.current[props.currentIndex];

    if (!container || !currentItem) return;

    cancelRef.current?.();

    const containerRect = container.getBoundingClientRect();
    const itemRect = currentItem.getBoundingClientRect();

    const scrollLeft =
      container.scrollLeft +
      (itemRect.left - containerRect.left) -
      containerRect.width / 2 +
      itemRect.width / 2;

    cancelRef.current = smoothScrollX(container, scrollLeft, 300);
  }, [props.currentIndex]);

  return (
    <Presentation
      {...props}
      containerRef={containerRef}
      itemRefs={itemRefs}
    />
  );
};
